import store from "../../../../store";
import { MUTUAL_FUNDS_CLEAR_SCHEMES_DATA, MUTUAL_FUNDS_SCHEMES, MUTUAL_FUNDS_SCHEMES_APPLY_SORT, MUTUAL_FUNDS_SCHEMES_CLEAR_MSG, MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA, MUTUAL_FUNDS_SCHEMES_CLEAR_SORT, MUTUAL_FUNDS_SCHEMES_ERROR, MUTUAL_FUNDS_SCHEMES_HIDE_ERROR, MUTUAL_FUNDS_SCHEMES_PARAMS, MUTUAL_FUNDS_SCHEMES_START_LOADER, MUTUAL_FUNDS_SCHEMES_STOP_LOADER, MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER, MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER, MUTUAL_FUNDS_SCHEMES_UPDATE, MUTUAL_FUNDS_SCHEMES_UPDATE_MSG, MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA, MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA, } from "../interface/iMutualFundsSchemes";
var MutualFundsSchemesActions = /** @class */ (function () {
    function MutualFundsSchemesActions() {
        this.dispatch = store.dispatch;
    }
    MutualFundsSchemesActions.prototype.startMutualFundsSchemeLoader = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_START_LOADER,
        });
    };
    MutualFundsSchemesActions.prototype.stopMutualFundsSchemeLoader = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_STOP_LOADER,
        });
    };
    MutualFundsSchemesActions.prototype.startMutualFundsSchemeTableLoader = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER,
        });
    };
    MutualFundsSchemesActions.prototype.stopMutualFundsSchemeTableLoader = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER,
        });
    };
    MutualFundsSchemesActions.prototype.updateMsg = function (message) {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_UPDATE_MSG,
            payload: { message: message },
        });
    };
    MutualFundsSchemesActions.prototype.clearMsg = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_CLEAR_MSG,
        });
    };
    MutualFundsSchemesActions.prototype.getMutualFundsSchemesList = function (mutualFundsSchemes, update, totalPages) {
        if (update) {
            this.dispatch({
                type: MUTUAL_FUNDS_SCHEMES_UPDATE,
                payload: { mutualFundsSchemes: mutualFundsSchemes },
            });
        }
        else {
            this.dispatch({
                type: MUTUAL_FUNDS_SCHEMES,
                payload: { mutualFundsSchemes: mutualFundsSchemes, totalPages: totalPages },
            });
        }
    };
    MutualFundsSchemesActions.prototype.updateSortedData = function (mutualFundsSchemes) {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA,
            payload: { mutualFundsSchemes: mutualFundsSchemes },
        });
    };
    MutualFundsSchemesActions.prototype.applySearching = function (searchData, updateData) {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA,
            payload: { searchState: searchData, updatedData: updateData },
        });
    };
    MutualFundsSchemesActions.prototype.updateMutualFundsParams = function (paramsData) {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_PARAMS,
            payload: { paramsData: paramsData },
        });
    };
    MutualFundsSchemesActions.prototype.applySorting = function (sortData, updateData) {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_APPLY_SORT,
            payload: {
                sortState: sortData,
                updatedData: JSON.parse(JSON.stringify(updateData)),
            },
        });
    };
    MutualFundsSchemesActions.prototype.clearSorting = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_CLEAR_SORT,
        });
    };
    MutualFundsSchemesActions.prototype.clearSearching = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA,
        });
    };
    MutualFundsSchemesActions.prototype.setError = function (payload, errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_ERROR,
            payload: { errorData: payload },
        });
    };
    MutualFundsSchemesActions.prototype.hideError = function (errorType) {
        this.dispatch({
            type: MUTUAL_FUNDS_SCHEMES_HIDE_ERROR,
        });
    };
    MutualFundsSchemesActions.prototype.clearMutualFundReduxData = function () {
        this.dispatch({
            type: MUTUAL_FUNDS_CLEAR_SCHEMES_DATA,
        });
    };
    return MutualFundsSchemesActions;
}());
export default MutualFundsSchemesActions;
